module.exports = __webpack_public_path__ + "static/2-52d41bd66f6e6a2793aa9ae79d2ba74a.jpg";